import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";

export class CountryPhoneListItem {
	id: number;
	name: string;
	imgSrc: string;
	mask: string;
}

@Component({
    selector: 'dropdownlist-country-phone-masks',
    templateUrl: './dropdownlist-country-phone-masks.component.html',
    styleUrls: ['./dropdownlist-country-phone-masks.component.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ],
    encapsulation: ViewEncapsulation.None,
})
export class DropdownListCountryPhoneMasksComponent {
    
    @Input() width: number = 75;
	@Input() disabled: boolean = false;
    
    @Output() setMask: EventEmitter<string> = new EventEmitter<string>();

    countryId: number = 1;
    
    countries: CountryPhoneListItem[] = [{
        id: 1,
        name: '+7',
        mask: "+7 (000) 000-00-00",
        imgSrc: "../../../../assets/images/countryFlags/ru.svg",
    }, {
        id: 2,
        name: '+375',
        mask: "+375 (00) 000-00-00",
        imgSrc: "../../../../assets/images/countryFlags/by.svg",
    }, {
        id: 3,
        name: '+994',
        mask: '+\\9\\94 (00) 000-00-00',
        imgSrc: "../../../../assets/images/countryFlags/az.svg",
    }, {
        id: 4,
        name: '+374',
        mask: '+374 (00) 000-000',
        imgSrc: "../../../../assets/images/countryFlags/am.svg",
    }, {
        id: 5,
        name: '+7',
        mask: '+7 (700) 000-00-00',
        imgSrc: "../../../../assets/images/countryFlags/kz.svg",
    }, {
        id: 6,
        name: '+996',
        mask: '+\\9\\96 (000) 000-000',
        imgSrc: "../../../../assets/images/countryFlags/kg.svg",
    }, {
        id: 7,
        name: '+373',
        mask: '+373 (00) 000-000',
        imgSrc: "../../../../assets/images/countryFlags/md.svg",
    }, {
        id: 8,
        name: '+992',
        mask: '+\\9\\92 (00) 000-00-00',
        imgSrc: "../../../../assets/images/countryFlags/tj.svg",
    }, {
        id: 9,
        name: '+998',
        mask: '+\\9\\98 (00) 000-00-00',
        imgSrc: "../../../../assets/images/countryFlags/uz.svg",
    }, {
        id: 10,
        name: '+993',
        mask: '+\\9\\93 (0) 00-00-00',
        imgSrc: "../../../../assets/images/countryFlags/tm.svg",
    },] as CountryPhoneListItem[];

    countryChange() {
        let country = this.countries.find(x => x.id == this.countryId);
        this.setMask.emit(country.mask);
    }

    public getAndSetPhoneMask(phoneNumber: string): string | null {
		if (!phoneNumber || phoneNumber.trim() == '') {
			let defaultCountry = this.countries.find(x => x.id == this.countryId);
			return defaultCountry.mask;
		} 
		
        let asKz = false;
		let mask = null;
		const digits = phoneNumber.replace(/\D/g, '');

		// Азербайджан (Азербайджанская Республика)
		if (digits.startsWith('994')) {
			mask = '+\\9\\94 (00) 000-00-00';
		}

		// Армения (Республика Армения)
		if (digits.startsWith('374')) {
			mask = '+374 (00) 000-000';
		}

		// Беларусь (Республика Беларусь)
		if (digits.startsWith('375')) {
			mask = '+375 (00) 000-00-00';
		}

		// Россия (Российская Федерация)
		if (digits.startsWith('7')) {
			mask = '+7 (000) 000-00-00';
		}

		// Казахстан (Республика Казахстан)
		if (digits.startsWith('77') || 
			digits.startsWith('76') || 
			digits.startsWith('70')) {
			mask = '+7 (000) 000-00-00';
            asKz = true;
		}

		// Кыргызстан (Кыргызская Республика)
		if (digits.startsWith('996')) {
			mask = "+\\9\\96 (000) 000-000";
		}

		// Молдова (Республика Молдова)
		if (digits.startsWith('373')) {
			mask = '+373 (00) 000-000';
		}

		// Таджикистан (Республика Таджикистан)
		if (digits.startsWith('992')) {
			mask = '+\\9\\92 (00) 000-00-00';
		}

		// Узбекистан (Республика Узбекистан)
		if (digits.startsWith('998')) {
			mask = '+\\9\\98 (00) 000-00-00';
		}

		// Туркменистан
		if (digits.startsWith('993')) {
			mask = '+\\9\\93 (0) 00-00-00';
		}

		if (mask != null) {
			let country = asKz
                ? this.countries.find(x => x.id == 5)
                : this.countries.find(x => x.mask == mask && x.id != 5);
			this.countryId = country.id;

			return mask;
		}

		return null;
	}
}